import React from "react";
import { Link } from "react-router-dom";

import "../assets/NavBar.css";

const NavBar = () => {
  return (
    <div className="Navbar">
      <Link to="/">
        <button>
          <span className="material-symbols-outlined">home</span>
        </button>
      </Link>
      <hr />
      <Link to="/PROJECTS">
        <button>
          <span className="material-symbols-outlined">folder_open</span>{" "}
        </button>
      </Link>
      <Link to="/CREATIVES">
        <button>
          <span className="material-symbols-outlined">photo_library</span>
        </button>
      </Link>
      {/* <Link to="/QUOTES">
        <button>
          <span class="material-symbols-outlined">format_quote</span>
        </button>
      </Link> */}
      <Link to="/RESUME">
        <button>
          <span className="material-symbols-outlined">receipt_long</span>
        </button>
      </Link>
    </div>
  );
};

export default NavBar;
